//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "selectcity",
  data(){
      return {
        cityData:[
          {
            "name": "热门城市",
            "items": [
              {
                "name": "BEIJING",
                "value": 1
              },
              {
                "name": "SHANGHAI",
                "value": 2
              }
            ]
          },
          {
            "name": "A",
            "items": [
              {
                "name": "ANSHAN",
                "value": 3
              },
              {
                "name": "ANQING",
                "value": 4
              }
            ]
          }
          ,
          {
            "name": "A",
            "items": [
              {
                "name": "ANSHAN",
                "value": 3
              },
              {
                "name": "ANQING",
                "value": 4
              }
            ]
          }
          ,
          {
            "name": "A",
            "items": [
              {
                "name": "ANSHAN",
                "value": 3
              },
              {
                "name": "ANQING",
                "value": 4
              }
            ]
          }
          ,
          {
            "name": "A",
            "items": [
              {
                "name": "ANSHAN",
                "value": 3
              },
              {
                "name": "ANQING",
                "value": 4
              }
            ]
          },
          {
            "name": "A",
            "items": [
              {
                "name": "ANSHAN",
                "value": 3
              },
              {
                "name": "ANQING",
                "value": 4
              }
            ]
          }
          ,
          {
            "name": "A",
            "items": [
              {
                "name": "ANSHAN",
                "value": 3
              },
              {
                "name": "ANQING",
                "value": 4
              }
            ]
          }
          ,
          {
            "name": "A",
            "items": [
              {
                "name": "ANSHAN",
                "value": 3
              },
              {
                "name": "ANQING",
                "value": 4
              }
            ]
          }
          ,
          {
            "name": "A",
            "items": [
              {
                "name": "ANSHAN",
                "value": 3
              },
              {
                "name": "ANQING",
                "value": 4
              }
            ]
          }
          ,
          {
            "name": "A",
            "items": [
              {
                "name": "ANSHAN",
                "value": 3
              },
              {
                "name": "ANQING",
                "value": 4
              }
            ]
          }
          ,
          {
            "name": "A",
            "items": [
              {
                "name": "ANSHAN",
                "value": 3
              },
              {
                "name": "ANQING",
                "value": 4
              }
            ]
          }

        ],
        selectCity:'BEIJING',
        height:null
      }
  },
  methods:{
    selectItem(item){
      console.log(item);
      this.selectCity=item.name
    }
  },
  created() {
  }
}



// WEBPACK FOOTER //
// ./src/components/selectcity/selectcity.vue